export default [
  { value: 'default', text: 'filter.sort.item1' },
  { value: 'byDiscount', text: 'filter.sort.item0' },
  { value: 'priceDescending', text: 'filter.sort.item3' },
  { value: 'priceAscending', text: 'filter.sort.item2' },
  { value: 'nameAscending', text: 'filter.sort.item4' },
  { value: 'nameDescending', text: 'filter.sort.item5' }
]